import React, { Component } from "react";
import PropTypes from "prop-types";
import Phone from "../ui/Phone";
import GetItem from "../../helpers/dataProviders/getItem";

class ThemeTemplatePicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			theme: null,
		};
	}
	componentDidMount() {
		GetItem("/themes/default").then(data => {
			this.setState({ theme: data.data });
		});
	}
	render() {
		const { theme } = this.state;
		return (
			<div className="ta-center">
				<h3 className="page-title">Pick A Theme</h3>
				{
					//TODO iterate over all theme templates
				}
				{theme ? (
					<div className="app-list">
						<Phone
							onSelect={() => this.props.pickTheme(theme)}
							itemKey={"1"}
							key={"one"}
							name={theme.name}
						/>
					</div>
				) : (
					<div>Loading...</div>
				)}
			</div>
		);
	}
}
ThemeTemplatePicker.propTypes = {
	pickTheme: PropTypes.func,
};
export default ThemeTemplatePicker;
